import { gql } from '@apollo/client';

export const ALL_RENUMERATION_SOURCES = gql`
  query AllRenumerationSources {
    renumerationSources: getRenumerationSources {
      id
      name
    }
  }
`;
